export const GET_USERS = "GET_USERS";
export const GET_USERS_DETAILS = "GET_USERS_DETAILS";
export const GET_USERS_DATE = "GET_USERS_DATE";
export const RESET_USERS_STATE = "RESET_USERS_STATE";
